/**
 * Classifies a Discord identity rejection. Empirically captured 2026-06-02:
 * clicking Cancel on the OAuth consent modal rejects authorize() with
 * { code: 5000, message: 'OAuth2 Error: access_denied: ...' }. 5000 is
 * Discord's mapping of the OAuth2 spec value `access_denied`. Anything else
 * (SDK init failure, RPC error, transport hiccup) falls back to
 * 'identity_error' so the player gets the generic couldntConnect surface,
 * not the misleading "allow access" copy. Wired into LobbySession via
 * App.buildSessionPromise and devRealSession.
 */
const DISCORD_OAUTH_ACCESS_DENIED = 5000;

export function classifyIdentityError(err: unknown): 'identity_denied' | 'identity_error' {
  const code = (err as { code?: unknown } | null | undefined)?.code;
  if (code === DISCORD_OAUTH_ACCESS_DENIED) return 'identity_denied';
  return 'identity_error';
}
